import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '../../lib/axios';
import { OWNER_KEY } from '../../lib/constants';
import { AxiosErrorResponse } from '../../lib/types';
import { GetItemProps } from '../types';

export const getOwner = (params: GetItemProps): Promise<any> => {
  return axios.get('/owner', { params: { ...params, perPage: '10' } });
};

export const useOwner = (params: GetItemProps) => {
  return useQuery<any, AxiosError<AxiosErrorResponse>>({
    queryKey: [OWNER_KEY, params.page || 1],
    queryFn: () => getOwner(params),
    keepPreviousData: true,
  });
};
